import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class FinalizeContractUseCase implements UseCase<Observable<Transaction<void>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(): Observable<Transaction<void>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.contractProvider.finalize(contract),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
